/** Keep approved referrals in private order metadata; Shopify applies discounts independently.
 * The merchant setting accepts a legacy code or [{code, expiry?}]. Omit expiry
 * only when the trial is reviewed against paid orders. No cart items are changed. */
async function recordReferral() {
  const config = document.getElementById('acf-referral-config');
  if (!(config instanceof HTMLScriptElement) || window.Shopify?.designMode) return;
  const raw = config.dataset.code?.trim();
  if (!raw) return;
  let configured;
  try { configured = raw.startsWith('[') ? JSON.parse(raw) : [{code:raw, expiry:config.dataset.expiry}]; }
  catch { return; }
  if (!Array.isArray(configured) || configured.length > 200) return;
  const allowed = new Map();
  for (const entry of configured) {
    if (!entry || typeof entry.code !== 'string') continue;
    const code = entry.code.trim().toUpperCase();
    if (!/^[A-Z0-9_-]{1,40}$/.test(code)) continue;
    const expiry = entry.expiry == null || entry.expiry === '' ? Infinity
      : typeof entry.expiry === 'string' ? Date.parse(entry.expiry) : NaN;
    if (expiry !== Infinity && !Number.isFinite(expiry)) continue;
    allowed.set(code, expiry);
  }
  const now = Date.now();
  const isActive = (code) => allowed.has(code) && now < allowed.get(code);
  const params = new URL(window.location.href).searchParams;
  const incoming = params.get('ref')?.trim().toUpperCase();
  let clear = params.has('ref') && incoming === '';
  let remembered;
  try {
    remembered = JSON.parse(sessionStorage.getItem('acf-referral-visit-v1') || 'null');
    if (clear) sessionStorage.removeItem('acf-referral-visit-v1');
    if (isActive(incoming)) {
      remembered = {code:incoming, expiry:allowed.get(incoming) === Infinity ? null : allowed.get(incoming)};
      sessionStorage.setItem('acf-referral-visit-v1', JSON.stringify(remembered));
    }
  } catch { if (isActive(incoming)) remembered = {code:incoming}; }
  if (!clear && remembered && !isActive(remembered.code)) {
    clear = true;
    try { sessionStorage.removeItem('acf-referral-visit-v1'); } catch { /* Optional storage. */ }
  }
  if (!clear && (!remembered || !isActive(remembered.code))) return;
  const controller = new AbortController();
  const cancel = () => controller.abort();
  window.addEventListener('pagehide', cancel, {once:true});
  try {
    const root = window.Shopify?.routes?.root || '/';
    const response = await fetch(root+'cart/update.js', {
      method:'POST', credentials:'same-origin', signal:controller.signal,
      headers:{'Content-Type':'application/json'},
      body:JSON.stringify({attributes:{__acf_referral_code:clear?'':remembered.code}}),
    });
    if (!response.ok) return;
    document.documentElement.dataset.acfReferralStatus = clear?'cleared':'recorded';
  } catch { /* A remembered visit retries on the next page; checkout is untouched. */ }
  finally { window.removeEventListener('pagehide', cancel); }
}
recordReferral();
